/* ==========================================================================
   Spotlight rail — prev/next arrows
   Ships as: assets/event-spotlight-rail.js  (loaded with defer)

   The rail itself is a native overflow-x scroller (touch swipe works with no
   JS at all). This only adds the desktop arrow affordance: click to advance
   by one screenful, and hide each arrow once there's nothing left that way.
   ========================================================================== */

(function () {
  'use strict';

  var rail = document.querySelector('[data-spotlight-rail]');
  if (!rail) return;

  var list = rail.querySelector('[data-spotlight-list]');
  var prev = rail.querySelector('[data-spotlight-prev]');
  var next = rail.querySelector('[data-spotlight-next]');
  if (!list || !prev || !next) return;

  function update() {
    var max = list.scrollWidth - list.clientWidth;
    prev.disabled = list.scrollLeft <= 1;
    next.disabled = list.scrollLeft >= max - 1;
  }

  function scrollBy(dir) {
    list.scrollBy({ left: dir * list.clientWidth * 0.92, behavior: 'smooth' });
  }

  prev.addEventListener('click', function () { scrollBy(-1); });
  next.addEventListener('click', function () { scrollBy(1); });

  list.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
